/**
 * Shared breakpoint constants for responsive design
 */
export const BREAKPOINTS = {
  MOBILE: 768,
} as const
